import { res } from "@/BaseComponent";
import { apiService } from "@/services/interceptor";
export default {
    async getList(): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/auto/keyword/list", null, {
                withCredentials: false,
            });
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async updateState(idx: number): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/auto/keyword/update/" + idx, null, {
                withCredentials: false,
            });
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async add(param: { keyword: string }): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/auto/keyword/add", param, {
                withCredentials: false,
            });
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
    async remove(idx: number): Promise<res> {
        const res = {} as res;
        try {
            const response = await apiService().post("/auto/keyword/delete/" + idx, null, {
                withCredentials: false,
            });
            return response.data;
        } catch (error) {
            res.returnCode = -1;
            console.info(error);
        }
        return res;
    },
};
